"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.function.name.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _statusIndicator = _interopRequireDefault(require("../../flyoutPanel/statusIndicator"));
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var AccordionWithStatus = function AccordionWithStatus(_ref) {
  var sections = _ref.sections,
    activeSection = _ref.activeSection,
    activeSections = _ref.activeSections,
    handleExpand = _ref.handleExpand,
    sectionStatuses = _ref.sectionStatuses,
    statusMappings = _ref.statusMappings;
  return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Accordion, {
    className: "gmmAccordion",
    fluid: true,
    styled: true
  }, sections && sections.map(function (section, i) {
    var isActive = activeSections ? _lodash.default.includes(activeSections, section.id) : activeSection === section.id;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: i,
      className: section.hideSection ? 'no-display' : '',
      "aria-hidden": section.hideSection
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Accordion.Title, {
      active: isActive,
      index: i,
      name: section.id,
      onClick: handleExpand
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#",
      className: "accordionControl",
      title: (isActive ? 'Collapse ' : 'Expand ') + section.name
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
      name: isActive ? 'caret down' : 'caret right'
    }), /*#__PURE__*/_react.default.createElement("span", null, section.name)), section.statusIndicator && /*#__PURE__*/_react.default.createElement(_statusIndicator.default, {
      status: section.status
    })), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Accordion.Content, {
      active: isActive
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
      className: "minimal-padding"
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, null, section.content)))));
  }));
};
AccordionWithStatus.propTypes = {
  sections: _propTypes.default.array.isRequired,
  activeSection: _propTypes.default.string.isRequired,
  handleExpand: _propTypes.default.func.isRequired,
  sectionStatuses: _propTypes.default.object,
  statusMappings: _propTypes.default.object
};
var _default = AccordionWithStatus;
exports.default = _default;